module.exports = __webpack_public_path__ + "img/bg_2.c6377f50.png";